import { useCallback, useEffect, useState } from 'react';
import { BrowserRouter, Navigate, Route, Routes, useNavigate } from 'react-router-dom';
import { ApiError, api, tokens } from './lib/api';
import { Shell } from './components/Shell';
import { Login } from './pages/Login';
import { Dashboard } from './pages/Dashboard';
import { CronJobs } from './pages/CronJobs';
import { Downloads } from './pages/Downloads';
import { Search } from './pages/Search';
import { Library } from './pages/Library';
import { Users } from './pages/Users';
import { Settings } from './pages/Settings';

type Ich = { id: number; username: string; role: string };

function Innen() {
  const [ich, setIch] = useState<Ich | null>(null);
  const [bereit, setBereit] = useState(false);
  const nav = useNavigate();

  const pruefen = useCallback(async () => {
    if (!tokens.access) { setIch(null); setBereit(true); return; }
    // Nur ein echtes 401/403 meldet ab. Ein Timeout oder 500er ist
    // voruebergehend — wer da den Token wegwirft, wirft den Nutzer raus,
    // obwohl seine Sitzung gilt.
    for (let versuch = 0; ; versuch++) {
      try {
        setIch(await api<Ich>('/auth/me'));
        setBereit(true);
        return;
      } catch (e) {
        if (e instanceof ApiError && (e.status === 401 || e.status === 403)) {
          tokens.clear();
          setIch(null);
          setBereit(true);
          return;
        }
        if (versuch >= 2) { setIch(null); setBereit(true); return; }
        await new Promise((r) => setTimeout(r, versuch === 0 ? 300 : 900));
      }
    }
  }, []);

  useEffect(() => { void pruefen(); }, [pruefen]);

  if (!bereit) return <div className="laedt">Lade …</div>;

  if (!ich) {
    return (
      <Routes>
        <Route path="/login" element={<Login aufAngemeldet={() => { void pruefen(); nav('/'); }} />} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    );
  }

  return (
    <Shell istAdmin={ich.role === 'admin'}>
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/search" element={<Search />} />
        <Route path="/cron-jobs" element={<CronJobs />} />
        <Route path="/library" element={<Library />} />
        <Route path="/downloads" element={<Downloads />} />
        {/* Nur fuer Verwaltung. Ohne diesen Schutz waere die Seite fuer jeden
            aufrufbar und wuerde erst an den 403ern der API scheitern —
            unschoen und verwirrend. */}
        {ich.role === 'admin' && <Route path="/admin/users" element={<Users />} />}
        {ich.role === 'admin' && <Route path="/admin/settings" element={<Settings />} />}
        <Route path="/login" element={<Navigate to="/" replace />} />
        <Route path="*" element={<div className="karte karte__leer">Diese Seite gibt es nicht.</div>} />
      </Routes>
    </Shell>
  );
}

export function App() {
  return <BrowserRouter><Innen /></BrowserRouter>;
}
